<!-- <h3 mat-dialog-title style="margin: 0;" *ngIf="runType == 'Refinery'">
  <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;margin-top: 5px;">
    <span [ngStyle]="{'color': farmTypeColor}">
      Run11 {{ runType }}: {{ nodeName }}
    </span>
    <span style="font-size: 12px;">
      Total Time Taken: {{ totalRefineryRunTime }}
    </span>
  </div>
</h3> -->
<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h3 mat-dialog-title cdkDragHandle class="dialog-title">
    <span class="title-left" [ngStyle]="{'color': farmTypeColor}">
      Run {{ runType }}
    </span>

    <span class="title-right">
      Total Time Taken: {{ totalRefineryRunTime }}
    </span>
  </h3>

  <div mat-dialog-content class="dialog-content">

    <div *ngFor="let returnResult of returnData" style="margin-bottom: 0px;">

      <!-- Node header -->
      <div
        [ngStyle]="{
          'font-size': '11px',
          'color': nodeFarmtypeUtil.toFarmtypeColor(returnResult.nodeFarmType),
          'margin-top': '15px',
          'margin-bottom': '3px',
          'font-weight': '500'
        }">
        Node Run: {{ returnResult.nodeDescriptor }}
      </div>

      <!-- Table -->
      <table style="width:99%; border-collapse: collapse;">

        <tr align="left" style="font-size: 10px;">
          <th class="translistview ellipsis-cell">Function</th>
          <th style="width:100px; padding: 0px 1px;">Transform Type</th>
          <th style="width:70px; padding: 0px 1px;">Run Time</th>
          <th style="width:70px; padding: 0px 1px;">Output Rows</th>
          <th style="width:70px; padding: 0px 1px;">Output Cols</th>
          <th style="width:70px; padding: 0px 1px;">Status</th>
          <th style="padding: 0px 1px;">Details</th>
        </tr>

        <tr *ngFor="let row of returnResult.transformerData"
            style="font-size: 10px;" class="translistview">
          <td class="translistview ellipsis-cell" matTooltip="{{ row.processName }}" [matTooltipDisabled]="!row.processName || row.processName.length <= 50">
            {{ row.processName?.length > 50 ? (row.processName | slice:0:50) + '...' : row.processName }}
          </td>
          <td class="translistview no-wrap-cell">{{ TransformTypeUtil.toString(row.transformType) }}</td>
          <td class="translistview">{{ row.timeTaken }}</td>
          <td class="translistview">{{ row.outputRows }}</td>
          <td class="translistview">{{ row.outputCols }}</td>
          <td
            class="translistview"
            [ngClass]="{
              'disabled-text': row.status == 'Disabled',
              'success-text': row.status != 'Disabled' && row.statusCode == 200,
              'error-text': row.status != 'Disabled' && row.statusCode != 200 && row.statusCode != 102 && row.statusCode != 105,
              'waiting-text': row.status != 'Disabled' && row.statusCode == 102,
              'notrun-text': row.status != 'Disabled' && row.statusCode == 105
            }">
            {{ row.status }}
          </td>
          <td class="translistview" matTooltip="{{ row.message }}" [matTooltipDisabled]="!row.message || row.message.length <= 30" class="no-wrap-cell">
            {{ row.message?.length > 30 ? (row.message | slice:0:30) + '...' : row.message }}
          </td>
        </tr>

        <!-- Totals (no border lines) -->
        <!-- <tr>
          <td colspan="6" style="padding-top: 8px;"></td>
        </tr> -->

        <tr style="font-size: 10px; font-weight: 600;"   *ngIf="returnResult?.total_transformer_time_taken !== ''">        
          <td colspan="1" style="color: orange;width: 150px;" class="translistview no-wrap-cell">
            Total Transformers Runtime
          </td>
          <td></td>
          <td colspan="1" style="color: orange; font-weight: 600;" class="translistview">
            {{ returnResult.total_transformer_time_taken }}
          </td>
          <td colspan="4"></td>
        </tr>

        <tr style="font-size: 10px; font-weight: 600;">
          <td colspan="1" style="color: orange;width: 150px;" class="translistview no-wrap-cell">
            Total Time Taken
          </td>
          <td></td>
          <td colspan="1" style="color: orange; font-weight: 600;" class="translistview">
            {{ returnResult.total_time_taken }}
          </td>
          <td colspan="3"></td>
        </tr>

      </table>
    </div>
  </div>

  <mat-dialog-actions align="end" style="padding-top: 6px;">
    <button
      (click)="saveAsPDF()"
      mat-raised-button>
      Save as PDF
    </button>
    <button
      (click)="cancel()"
      mat-raised-button
      mat-dialog-close
      tabindex="-1">
      Close
    </button>
  </mat-dialog-actions>
</div>